'use client'

import React, {useEffect} from "react";
import {Metadata} from "next";
import NewErrorContent from "@/app/components/atomic/organisms/NewErrorContent";
import Header from "@/app/components/base/Header";
import FooterNewClient from "@/app/components/base/FooterNewClient";

export default function Error({error, reset}: { error: Error; reset: () => void }) {
    const isDev = process.env.NODE_ENV === 'development'

    useEffect(() => {
        console.error(error)
    }, [error])

    const content = (
        <div>
            <h1 className="text-4xl font-bold">Une erreur est survenue</h1>
            <p className="text-xl text-blue-800">
                Pas de panique, ce n’est pas vous, c’est nous 😅<br />
                L’équipe technique est sur le coup.
            </p>

            {isDev && (
                <pre className="bg-red-100 p-4 text-sm text-left rounded shadow max-w-full overflow-x-auto">
                        {error.message}
                    {'\n'}
                    {error.stack}
                    </pre>
            )}
        </div>
    )

    return (
        <div className="flex flex-col min-h-screen">
            <Header />
            <NewErrorContent>{content}</NewErrorContent>
            <FooterNewClient />
        </div>
    )
}

export async function generateMetadata(): Promise<Metadata> {
    return {
        title: `Erreur 500 - Erreur technique`,
        metadataBase: new URL(process.env.NEXT_PUBLIC_RM_BASE_URL ?? 'https://reassurez-moi.fr'),
        description: 'Une erreur technique est survenue, on est sur le coup',
    }
}
